// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const ManufacturersPage = () => {
  return <MasterDataListPage type="manufacturers" />;
};

export default ManufacturersPage;